export const RESET_PASSWORD = 'app/resetPassword/RESET_PASSWORD';
export const RESET_PASSWORD_RETURN = 'app/resetPassword/RESET_PASSWORD_RETURN';
export const RESET_PASSWORD_RETURN_ERROR = 'app/resetPassword/RESET_PASSWORD_RETURN_ERROR';
